module.exports = __webpack_public_path__ + "img/Urban_Solar_80X30.6833dfd8.png";